import { CustomerPaymentMethodModel } from './models/customer-payment.method';
import { CustomerPaymentMethodPipe }  from './customer-payment.method.pipe';

export function CustomerPaymentMethodFilter ( customerPaymentMethodPipe : CustomerPaymentMethodPipe ) {
  return ( id : string, paymentMethods : Array<CustomerPaymentMethodModel> = [] ) : string => customerPaymentMethodPipe.transform(id, paymentMethods);
}